import React, { ReactNode, useEffect } from 'react'
import i18n from 'live/services/i18n'
import LiveTooltip from 'live/components/ui/tooltip'
import { LiveBlueIcon } from '../../../../common/components/actions/edit'
import styled from 'styled-components'

interface FollowingGlobalSpanIconProps {
    follow: boolean
    onClick: () => void
}

export default function FollowingGlobalSpanIcon({ follow, onClick }: FollowingGlobalSpanIconProps): JSX.Element {
    return (
        /* vscode alerts error in the content, but its working  */
        <LiveTooltip
            content={
                <span>
                    {i18n('This content') + ' '} <b>{i18n(`${follow ? 'follows' : 'doesn’t follow'}`)}</b>{' '}
                    {' ' + i18n('the global content timespan')}
                </span>
            }
            position="top"
        >
            <StyledLiveBlueIcon
                className={`unfollowIcon--icon far fa-${follow ? 'link' : 'unlink'}`}
                onClick={() => onClick()}
                followSpan={follow}
            />
        </LiveTooltip>
    )
}

const StyledLiveBlueIcon = styled(LiveBlueIcon)<{ followSpan: boolean }>`
    color: ${({ followSpan, theme }) => (!followSpan ? theme['gray-800'] : theme['blue-500'])};
    :hover {
        color: ${({ followSpan, theme }) => (!followSpan ? theme['gray-800'] : theme['blue-400'])};
    }
`
